import VueI18n from 'vue-i18n';
import Vue from 'vue';

Vue.use(VueI18n);

const messages = {
    'en': {
        EnLanguage: 'English',
        EsLanguage: 'Spanish',
        CatLanguage: 'Catalan',
        inputCode: 'Input Access code:',
        btnVerify: 'Verify',
        btnSubmit: 'Submit',
        labelName: "Name and Surname",
        labelEmail: "Email address",
        placeHolderName: "Enter your name",
        placeHolderEmail: "example@lallucana.com",
        links: 'Essential Links',
        ecosystem: 'Ecosystem',
        language: "Language",
        playerMessageSendQuestion: "Send questions to the speakers",
        playerBtnSendMessage: 'send',
        playerBtnDownloadCsv: "Download chat in CSV file",
        playerLinkAdminPage: 'Admin Page',
        playerMessageName: "You",
        playerSpanTotalUsers: "Total users:",
        adminBtnShowUsers: "Show Users",
        adminBtnShowCodes: "Show Codes",
        adminModalTitle: "Create Access Code",
        adminModalWebinarTitle: "Webinar Title English:",
        adminModalWebinarTitleEs: "Webinar Title Spanish:",
        adminModalWebinarTitleCat: 'Webinar Title Catalan',
        adminModalWebinarSubTitle: "Webinar Sub Title English:",
        adminModalWebinarSubTitleEs: "Webinar Sub Title Spanish:",
        adminModalWebinarSubTitleCat: 'Webinar Sub Title Catalan',
        adminModalDivPromotionalCode: "Access Code:",
        adminModalPlaceholderInputTitle: "Enter title for this Webinar",
        adminModalPlaceholderInputSubTitle: 'Enter subtitle for this Webinar',
        adminModalWebinarUrl: 'English player url',
        adminModalWebinarUrlEs: 'Spanish player url',
        adminModalWebinarUrlCat: 'Catalan player url',
        adminModalPlaceholderInputCode: "Enter code",
        adminModalDivChooseDate: "Choose Date:",
        adminModalDivChooseHour: "Choose Hour:",
        adminModalDivChooseDateExpire: "Choose Date to Expire :",
        adminModalDivChooseHourExpire: "Choose Hour to Expire:",
        adminModalWebinarAddQuestion: 'Add new Question in English',
        adminModalWebinarAddQuestionEs: 'Add new Question in Spanish',
        adminModalWebinarAddQuestionCat: 'Add new Question in Catalan',
        adminModalWebinarShowQuestions: 'Show English Questions',
        adminModalWebinarShowQuestionsEs: 'Show Spanish Questions',
        adminModalWebinarShowQuestionsCat: 'Show Catalan Questions',
        adminModalBtnAddCode: "Add",
        adminModalBtnClose: "Close",
        adminModalBtnSaveChanges: "Save Changes",
        adminModalBtnSave: 'Save',
        adminModalBtnNewCode: 'Create',
        adminThName: "Name",
        adminThSurname: "Surname",
        adminThEmail: "Email",
        adminThCompany: "Organization",
        adminThDate: "Date",
        adminThPromotionalCode: "Access Code",
        adminThTitle: "Title",
        adminThSubTitle: "Sub Title",
        adminThBeginningDate: "Beginning Date",
        adminThExpirationDate: "Expiration Date",
        adminThDelete: "Delete",
        adminThPlayerUrl: 'Player Url',
        adminPaginatorPrevious: "Previous",
        adminPaginatorNext: "Next",
        adminBtnDownloadCSV: "Download users in CSV file",
        adminBtnDeleteCode: "Delete Event",
        adminBtnMoreInfo: 'Show More information',
        adminTitleCSVFileName: "Name and Surname",
        adminTitleCSVFileEmail: "Email",
        adminTitleCSVFileDate: "Date",
        adminModalCreateEvent: 'Create New Event',
        adminModalEditEvent: 'Edit Event',
        adminModalEditEventSuccess: 'Event saved successfully',
        adminModalEditAnswer: 'Edit Answers',
        adminModalDeleteQuestion: 'Delete Question',
        adminModalShowAnswers: 'Show Ansers',
        adminNavBarLogOut: 'Log out',
        loginCheckBoxOptionA: "Go to player",
        loginCheckBoxOptionB: "Go to admin page",
        loginLabelPassword: "Enter a password",
        loginLabelEmail: "Email",
        loginLabelCompany: 'Organization Name',
        loginPlaceHolderEmail: "input email",
        loginPlaceHolderPassword: "input password",
        loginPlaceHolderCompany: 'input your organization name',
        loginBtnSubmit: "Log In",
        loginLabelRegister: 'You don\'t have an account,  sign up',
        loginModalTitleResetPassword: 'Restore the Password',
        loginLabelResetPassword: "Forgot your password?",
        loginModalButtonSend: 'Send',
        loginModalInfo: 'An email will be sent to you with a link to restore your password, at the address you enter below',
        loginModalSendEmailSuccess: 'The email has been sent correctly',
        loginCheckboxLabelSelectOption: 'Select an option: ',
        registerBtnSubmit: 'Sign Up',
        registerLabelPassword: 'Create a password',
        registerLabelRepeatedPassword: 'Repeat the password',
        errorMessageNoPassword: 'Password is required',
        errorMessageLengthPassword: 'Length must be greater than 6',
        errorMessageSamePassword: 'Passwords must be the same',
        errorMessageInvalidMailFormat: 'Please enter a valid email',
        errorMessageNoAcceptTerms: "You must accept the conditions",
        toastedMessageVerifyCredentials: 'Verifying credentials',
        toastedMessageVerifyCode: 'Verifying code',
        errorMessageCudNotConnectServer: 'Could not connect to the server',
        errorMessageUsernamePassword: 'Username or password incorrect',
        errorMessageInvalidPasswordOrUser: 'Invalid email or password',
        errorMessageInvalidPromotionalCode: 'Invalid code',
        timeoutErrorMessageEmailAdrressFormat: 'The email address is badly formatted',
        errorMessageNameAndSurname: 'Enter a name and surname',
        errorMessageSomethingWrong: 'Error, something you entered is wrong',
        errorMessageInvalidDate: 'Date is not valid',
        errorMessageUserNotExist:'This user does not exist',
        errorMessageToken:'Invalid token',
        errorMessageAlreadyRegistered: 'This user is already registered',
        errorMessageInvalidUser: 'You do not have permissions to perform this action',
        errorMessageDateExpires: 'Date expires',
        successMessageUserDeletedCode: 'Deleted successfully',
        successMessageUserUpdateCode: 'Access code updated successfully',
        successMessageUserRegister: 'Created successfully',
        successMessageVerifiedCode: 'Correct Code',
        registerTitle: 'Sign Up',
        registerLabelLogin: 'You already have an account, log in',
        errorMessageRequiredSurname: 'Require surname',
        labelNoTimeSelected: 'No time selected',
        secretaryOptionsChatModalTitle: 'Choose one of the options',
        secretaryBtnSendModerator: 'Send to Moderator',
        secretaryBtnSendResponseUser: 'Response User',
        secretaryOptionsChatModalAlertTitle: 'Are you sure you want to send it',
        secretaryBtnSendOk: 'Send',
        secretaryBtnSendCancel: 'Cancel',
        secretaryTabQuestions: 'Questions',
        eventInformationTitle: "Event Information",
        eventInformationTitleEn: 'English Title',
        eventInformationTitleEs: 'Spanish Title',
        eventInformationTitleCat: 'Catalan Title',
        eventInformationSubTitleEn: 'English Sub Title',
        eventInformationSubTitleEs: 'Spanish Sub Title',
        eventInformationSubTitleCatalan: 'Catalan Sub Title',
        eventInformationPlayerUrlEn: 'English Player Url',
        eventInformationPlayerUrlEs: 'Spanish Player Url',
        eventInformationPlayerUrlCat: 'Catalan Player Url',
        eventInformationQuestionsEn: 'English Questions',
        eventInformationQuestionsEs: 'Spanish Questions',
        eventInformationQuestionsCat: 'Catalan Questions',
        eventInformationGoBackBtn: 'Go Back',
        eventInformationActiveChat: 'Chat activated',
        eventInformationTotalUsers: 'Total users',
        eventSuccessModified: 'Saved Changes',
        userPlayerMessageArrived: 'You have a new message',
        secretaryShowGraphs: 'Show Graphs',
        secretaryQuestionSended: 'Question Sended',
        secretarySendQuestion: 'Send Question',
        secretaryShowAnswers: 'Show Answers',
        secretaryInputSeconds: 'Enter the number of seconds',
        secretaryTitleResponseTime: 'Response Time',
        dashboardTitleGraph: 'Question',
        dashboardTitleCharts: 'Charts',
        adminModalWebinarStartImageCat: 'Select an initial cover for Catalan',
        adminModalWebinarEndImageCat: 'Select an ending cover for Catalan',
        adminModalWebinarStartImageEs: 'Select an initial cover for Spanish',
        adminModalWebinarEndImageEs: 'Select an ending cover for Spanish',
        adminModalWebinarStartImageEn: 'Select an initial cover for English',
        adminModalWebinarEndImageEn: 'Select an ending cover for English',
        adminModalWebinarBrowseBtnLabel: 'Browse',
        adminModalWebinarPlaceholderUploadImage: 'Choose an image...',
        adminModalWebinarUploadBtnLabel: 'Upload image',
        secretaryWebinarTabChatLabel: 'Chat with the secretary',
        moderatorWebinarTabGeneralLabel: 'General',
        moderatorWebinarTabChatLabel: 'Chat with the moderator',
        adminBtnManageEvent: 'Manage event',
        eventInformationActiveQuestions: 'Questions activated',
        eventInformationActiveChroma: 'Chroma activated',
        adminPanicPosterLabel: 'Panic poster',
        registerLegalText1: "Barcelona Time Use Initiative for a Healthy Society will use your personal data to manage your registration to the Time Use Week 2020 event; to send relevant information related to the event; and, if you have indicated so, to send communications about the activities of the association. To use your right to access, rectify, suppress, limit and oppose your personal data, you can contact us at info@timeuse.barcelona. ",
        acceptTerms: "I have read, understood and accept the personal data processing",
        reciveInfoYes: 'YES',
        reciveInfoNo: 'NO',
        reciveLabelInfo: 'You want to subscribe to the "Barcelona Time Use" newsletter. '




    },
    'es': {
        EnLanguage: 'Inglés',
        EsLanguage: 'Español',
        CatLanguage: 'Catalán',
        inputCode: 'Ingrese el código de acceso: ',
        btnVerify: 'Verificar',
        btnSubmit: 'Enviar',
        labelName: 'Nombre y Apellido',
        labelEmail: "Correo electrónico",
        placeHolderName: "Ingrese su nombre",
        placeHolderEmail: "example@lallucana.com",
        plugins: 'Plugins de CLI instalados',
        links: 'Enlaces esenciales',
        ecosystem: 'Ecosistema',
        language: "Idioma",
        playerMessageSendQuestion: "Envia preguntas a los ponentes",
        playerBtnSendMessage: 'enviar',
        playerBtnDownloadCsv: "Descarga el chat en un fichero CSV",
        playerLinkAdminPage: "Página de Administrador",
        playerMessageName: "Tú",
        playerSpanTotalUsers: "Usuarios totales: ",
        adminBtnShowUsers: "Mostrar Usuarios",
        adminBtnShowCodes: "Mostrar códigos",
        adminModalTitle: "Crear código de acceso",
        adminModalWebinarTitle: "Título del seminario web en Inglés:",
        adminModalWebinarTitleEs: "Título del seminario web en Español:",
        adminModalWebinarTitleCat: 'Título del seminario web en Catalán',
        adminModalWebinarSubTitle: "Subtítulo del seminario web en Inglés: ",
        adminModalWebinarSubTitleEs: "Subtítulo del seminario web en Español:",
        adminModalWebinarSubTitleCat: 'Subtítulo del seminario web en Catalán',
        adminModalWebinarUrl: 'Url del player en Inglés',
        adminModalWebinarUrlEs: 'Url del player en Español',
        adminModalWebinarUrlCat: 'Url del player en Catalán',
        adminModalDivPromotionalCode: "Código de Acceso:",
        adminModalPlaceholderInputTitle: "Ingrese el título para este seminario web",
        adminModalPlaceholderInputSubTitle: "Ingrese el subtítulo para este seminario web",
        adminModalPlaceholderInputCode: "Ingrese el código",
        adminModalDivChooseDate: "Elegir fecha:",
        adminModalDivChooseHour: "Elegir hora:",
        adminModalDivChooseDateExpire: "Elija la fecha de caducidad:",
        adminModalDivChooseHourExpire: "Elija la hora de caducidad:",
        adminModalBtnAddCode: "Añadir",
        adminModalBtnClose: "Cerrar",
        adminModalBtnSaveChanges: "Guardar Cambios",
        adminModalBtnSave: 'Guardar',
        adminModalWebinarAddQuestion: 'Añade una nueva Pregunta en Inglés',
        adminModalWebinarAddQuestionEs: 'Añade una nueva Pregunta en Español',
        adminModalWebinarAddQuestionCat: 'Añade una nueva Pregunta en Catalán',
        adminModalWebinarShowQuestions: 'Mostrar las preguntas en Inglés',
        adminModalWebinarShowQuestionsEs: 'Mostrar las preguntas en Español',
        adminModalWebinarShowQuestionsCat: 'Mostrar las preguntas en Catalan',
        adminModalBtnNewCode: 'Crear',
        adminThName: "Nombre",
        adminThSurname: "Apellido",
        adminThEmail: "Correo Electrónico",
        adminThCompany: "Empresa",
        adminThDate: "Fecha",
        adminThPlayerUrl: 'Player Url',
        adminThPromotionalCode: 'Código de Acceso',
        adminThTitle: "Título",
        adminThSubTitle: "Subtítulo",
        adminThBeginningDate: "Fecha de Inicio",
        adminThExpirationDate: "Fecha de Caducidad",
        adminThDelete: "Eliminar",
        adminPaginatorPrevious: "Anterior",
        adminPaginatorNext: "Siguiente",
        adminBtnDownloadCSV: "Descargar usuarios en un fichero CSV",
        adminBtnDeleteCode: "Eliminar Evento",
        adminBtnMoreInfo: 'Mostrar más información',
        adminTitleCSVFileName: "Nombre y Apellido",
        adminTitleCSVFileEmail: "Correo electrónico",
        adminTitleCSVFileDate: "Fecha",
        adminModalCreateEvent: 'Crear un Evento',
        adminModalEditEvent: 'Editar Evento',
        adminModalEditEventSuccess: 'Evento guardado con exito',
        adminModalEditAnswer: 'Editar Respuestas',
        adminModalDeleteQuestion: 'Eliminar Pregunta',
        adminModalShowAnswers: 'Mostrar Respuestas',
        adminNavBarLogOut: 'Cerrar sesión',
        loginCheckBoxOptionA: "Ir al player",
        loginCheckBoxOptionB: "Ir a la página del administrador",
        loginLabelEmail: "Correo Electrónico",
        loginLabelCompany: 'Nombre de la Empresa:',
        loginLabelPassword: "Ingrese la Contraseña",
        loginPlaceHolderEmail: "Ingrese el correo electrónico",
        loginPlaceHolderPassword: "Ingrese la contraseña",
        loginPlaceHolderCompany: 'Ingrese el nombre de su empresa',
        loginBtnSubmit: "Iniciar Sesión",
        loginLabelRegister: 'No tienes cuenta, registrate',
        loginLabelResetPassword: "Has olvidado tu contraseña?",
        loginModalTitleResetPassword: 'Restaurar la Contraseña',
        loginModalButtonSend: 'Enivar',
        loginModalInfo: 'Se le enviará un correo con un link, para restaurar su contraseña, en la dirección que introduzca a continuación',
        loginModalSendEmailSuccess: 'Se ha enviado el email correctamente',
        loginCheckboxLabelSelectOption: 'Selecciona una opción: ',
        registerBtnSubmit: "Regístrate",
        registerLabelPassword: 'Crea una Contraseña',
        registerLabelRepeatedPassword: 'Escribe la Contraseña de Nuevo',
        errorMessageNoPassword: 'Se requiere de una contraseña',
        errorMessageLengthPassword: 'La longitud debe ser mayor que 6',
        errorMessageSamePassword: 'Las contraseñas deben coicidir',
        errorMessageInvalidMailFormat: 'Por favor introduzca una dirección de correo electrónico válida',
        toastedMessageVerifyCredentials: 'Verificación de credenciales',
        toastedMessageVerifyCode: 'Verificando el código',
        errorMessageCudNotConnectServer: 'No se pudo conectar con el servidor',
        errorMessageUsernamePassword: 'Usuario o contraseña incorrectos',
        errorMessageInvalidPasswordOrUser: 'Correo electrónico o contraseña no válidos',
        errorMessageInvalidPromotionalCode: 'Codigo incorrecto',
        timeoutErrorMessageEmailAdrressFormat: 'La dirección de correo electrónico está mal formateada',
        errorMessageNameAndSurname: 'Ingrese un nombre y un apellido',
        errorMessageInvalidDate: 'La fecha no es válida',
        errorMessageUserNotExist:'Este usuario no existe',
        errorMessageToken:'El token no es valido',
        errorMessageAlreadyRegistered: 'Este usuario ya está registrado',
        errorMessageInvalidUser: 'No tienes permisos para realizar esta acción',
        errorMessageDateExpires: 'La fecha ha expirado',
        successMessageUserDeletedCode: 'Eliminado correctamente',
        successMessageUserUpdateCode: 'Código de acceso actualizado con éxito',
        successMessageUserRegister: 'Creado con éxito',
        successMessageVerifiedCode: 'Código correcto',
        registerTitle: 'Registrate',
        registerLabelLogin: 'Ya tienes cuenta, logueate',
        errorMessageRequiredSurname: 'Se necesita un apellido',
        errorMessageSomethingWrong: 'Error, algo que ingresaste está mal',
        labelNoTimeSelected: 'Sin tiempo seleccionado',
        secretaryOptionsChatModalTitle: 'Escoge una de las opciones',
        secretaryBtnSendModerator: 'Enviar al Moderador',
        secretaryBtnSendResponseUser: 'Responder al Usuario',
        secretaryOptionsChatModalAlertTitle: 'Seguro que lo quieres enviar',
        secretaryBtnSendOk: 'Enviar',
        secretaryBtnSendCancel: 'Cancelar',
        secretaryTabQuestions: 'Preguntas',
        eventInformationTitle: "Información del Evento",
        eventInformationTitleEn: 'Título en Inglés',
        eventInformationTitleEs: 'Título en Español',
        eventInformationTitleCat: 'Titulo en Catalan',
        eventInformationSubTitleEn: 'Subtítulo en Inglés',
        eventInformationSubTitleEs: 'Subtítulo en Español',
        eventInformationSubTitleCatalan: 'Subtítulo en Catalán',
        eventInformationPlayerUrlEn: 'Url del Player en Inglés',
        eventInformationPlayerUrlEs: 'Url del Player en Español',
        eventInformationPlayerUrlCat: 'Url del Player en Catalán',
        eventInformationQuestionsEn: 'Preguntas en Inglés',
        eventInformationQuestionsEs: 'Preguntas en Español',
        eventInformationQuestionsCat: 'Preguntas en Catalán',
        eventInformationGoBackBtn: 'Regresar',
        userPlayerMessageArrived: 'Tienes un nuevo mensaje',
        eventInformationTotalUsers: 'Total de usuarios',
        eventInformationActiveChat: 'Chat activado',
        eventSuccessModified: 'Cambios Guardados',
        secretaryShowGraphs: 'Mostrar Gráficos',
        secretaryQuestionSended: 'Pregunta  Enviada',
        secretarySendQuestion: 'Envia la Pregunta',
        secretaryShowAnswers: 'Mostrar Respuestas',
        secretaryInputSeconds: 'Introduzca el número de segundos',
        secretaryTitleResponseTime: 'Tiempo de Respuesta',
        dashboardTitleGraph: 'Pregunta',
        dashboardTitleCharts: 'Gráficos',
        adminModalWebinarStartImageCat: 'Añade una imagen de portada inicial en Catalán',
        adminModalWebinarEndImageCat: 'Añade una imagen de portada final en Catalán',
        adminModalWebinarStartImageEs: 'Añade una imagen de portada inicial en Español',
        adminModalWebinarEndImageEs: 'Añade una imagen de portada final en Español',
        adminModalWebinarStartImageEn: 'Añade una imagen de portada inicial en Inglés',
        adminModalWebinarEndImageEn: 'Añade una imagen de portada final en Inglés',
        adminModalWebinarBrowseBtnLabel: 'Buscar',
        adminModalWebinarPlaceholderUploadImage: 'Selecciona una imagen...',
        adminModalWebinarUploadBtnLabel: 'Subir imagen',
        secretaryWebinarTabChatLabel: 'Chat con el secretario',
        moderatorWebinarTabGeneralLabel: 'General',
        moderatorWebinarTabChatLabel: 'Chat con el moderador',
        adminBtnManageEvent: 'Gestionar evento',
        eventInformationActiveQuestions: 'Preguntas activadas',
        eventInformationActiveChroma: 'Chroma activado',
        adminPanicPosterLabel: 'Póster del pánico',
        acceptTerms: "He leído, entiendo y acepto el ",
        reciveInfoYes: 'SI',
        reciveInfoNo: 'NO',
        reciveLabelInfo: 'Deseo recibir información de otras actividades de  “Barcelona Time  Use”.'



    },
    'cat': {
        EnLanguage: 'Anglès',
        EsLanguage: 'Espanyol',
        CatLanguage: 'Català',
        inputCode: "Introduïu el codi  d'accés ",
        btnVerify: 'Comprovar',
        btnSubmit: 'Enviar',
        labelName: 'Nom i Cognom',
        labelEmail: "Correu electrònic",
        placeHolderName: "Introdueix el teu nom",
        placeHolderEmail: "example@lallucana.com",
        plugins: 'Plugins de CLI instal·lats',
        links: 'Enllaços essencials',
        ecosystem: 'Ecosistema',
        language: "Idioma",
        playerMessageSendQuestion: "Envia preguntes als ponents",
        playerBtnSendMessage: 'Enviar',
        playerBtnDownloadCsv: "Descarrega el xat en un fitxer CSV",
        playerLinkAdminPage: "Pàgina d'Administrador",
        playerMessageName: "Tu",
        playerSpanTotalUsers: "Nombre de membres: ",
        adminBtnShowUsers: "Mostra Usuaris",
        adminBtnShowCodes: "Mostra els codis",
        adminModalTitle: "Crear codi  d'accés",
        adminModalWebinarTitle: "Títol del seminari web en Anglès: ",
        adminModalWebinarTitleEs: "Títol del seminari web en Espanyol: ",
        adminModalWebinarTitleCat: 'Títol del seminari web en Català: ',
        adminModalWebinarSubTitle: "Subtítol del seminari web en Anglès: ",
        adminModalWebinarSubTitleEs: "Subtítol del seminari web en Espanyol: ",
        adminModalWebinarSubTitleCat: 'Subtítol del seminari web en Català: ',
        adminModalDivPromotionalCode: "Codi d'Accés: ",
        adminModalPlaceholderInputTitle: "Introduïu el títol per a aquest seminari web",
        adminModalPlaceholderInputSubTitle: "Introduïu el subtítol per a aquest seminari web",
        adminModalPlaceholderInputCode: "Introduïu el codi",
        adminModalDivChooseDate: "Triar data:",
        adminModalDivChooseHour: "Triar hora: ",
        adminModalDivChooseDateExpire: "Trieu la data de caducitat:",
        adminModalDivChooseHourExpire: "Trieu la data de caducitat",
        adminModalBtnAddCode: "Afegir",
        adminModalBtnClose: "Tancar",
        adminModalBtnSaveChanges: "Desa els Canvis",
        adminModalBtnSave: 'Desar',
        adminModalWebinarAddQuestion: 'Afegeix una nova Pregunta en Anglès',
        adminModalWebinarAddQuestionEs: 'Afegeix una nova Pregunta en Espanyol',
        adminModalWebinarAddQuestionCat: 'Afegeix una nova Pregunta en Català',
        adminModalWebinarShowQuestions: 'Mostrar les preguntes en Anglès',
        adminModalWebinarShowQuestionsEs: 'Mostrar les preguntes en Espanyol',
        adminModalWebinarShowQuestionsCat: 'Mostrar les preguntas en Català',
        adminModalBtnNewCode: 'Crear',
        adminModalWebinarUrl: 'Url del player en Anglès',
        adminModalWebinarUrlEs: 'Url del player en Espanyol',
        adminModalWebinarUrlCat: 'Url del player en Català',
        adminThName: "Nom",
        adminThSurname: "Cognom",
        adminThEmail: "Correu Electrònic",
        adminThCompany: 'Organització',
        adminThDate: "Data",
        adminThPlayerUrl: 'Player Url',
        adminThPromotionalCode: 'Codi d\'Accés',
        adminThTitle: "Títol",
        adminThSubTitle: "Subtítol",
        adminThBeginningDate: "Data d'inici",
        adminThExpirationDate: "Data de caducitat",
        adminThDelete: "Eliminar",
        adminPaginatorPrevious: "Anterior",
        adminPaginatorNext: "Següent",
        adminBtnDownloadCSV: "Descarregar usuaris en un fitxer CSV",
        adminBtnDeleteCode: "Eliminar Esdeveniment",
        adminBtnMoreInfo: 'Mostrar més informació',
        adminTitleCSVFileName: "Nom i Cognoms",
        adminTitleCSVFileEmail: "Correu electrònic",
        adminTitleCSVFileDate: "Data",
        adminModalCreateEvent: 'Crear un Esdeveniment',
        adminModalEditEvent: "Editar l'Esdeveniment",
        adminModalEditEventSuccess: 'Esdeveniment guardat amb èxit',
        adminModalEditAnswer: 'Editar les Respostes',
        adminModalDeleteQuestion: 'Eliminar la Pregunta',
        adminModalShowAnswers: 'Mostrar les Respostes',
        adminNavBarLogOut: 'Tancar sessió',
        loginCheckboxLabelSelectOption: 'Selecciona una de les opcions',
        loginCheckBoxOptionA: "Anar a la pàgina d'administrador",
        loginCheckBoxOptionB: "Anar al player d'administrador",
        loginLabelEmail: "Correu Electrònic",
        loginLabelCompany: "Nom de la Organització",
        loginLabelPassword: "Escriu la contrasenya",
        loginPlaceHolderEmail: "Introduïu el correu electrònic",
        loginPlaceHolderPassword: "Introduïu la contrasenya",
        loginPlaceHolderCompany: "Introduïu el nom de la vostra organització",
        loginBtnSubmit: "Iniciar Sessió",
        loginLabelRegister: 'No tens compte, registra\'t',
        loginLabelResetPassword: "No recordes la contrasenya?",
        loginModalTitleResetPassword: 'Restaura la Contrasenya',
        loginModalButtonSend: 'Enviar',
        loginModalSendEmailSuccess: 'S\'ha enviat l\'email correctament',
        loginModalInfo: 'Se li enviarà un correu amb un link, per restaurar la seva contrasenya, a l\'adreça que introdueixi a continuació',
        registerLabelPassword: 'Crea un Contrasenya',
        registerLabelRepeatedPassword: "Escriu la Contrasenya de Nou",
        registerBtnSubmit: "Registra't",
        errorMessageNoPassword: 'Es requereix d\'una contrasenya',
        errorMessageLengthPassword: 'La longitud ha de ser més gran que 6',
        errorMessageSamePassword: 'Les contrasenyes han de ser iguals',
        errorMessageInvalidMailFormat: 'Si us plau introdueixi una adreça de correu electrònic vàlida',
        toastedMessageVerifyCredentials: 'Verificació de credencials',
        toastedMessageVerifyCode: 'Verificant el codi',
        errorMessageCudNotConnectServer: 'No s\'ha pogut connectar amb el servidor',
        errorMessageUsernamePassword: 'Usuari o contrasenya incorrectes',
        errorMessageInvalidPasswordOrUser: 'Correu electrònic o contrasenya no vàlids',
        errorMessageInvalidPromotionalCode: 'Codi incorrecte',
        timeoutErrorMessageEmailAdrressFormat: 'La direcció de correu electrònica està malament',
        errorMessageRequiredSurname: 'Es necessita un cognom',
        errorMessageInvalidDate: 'La data no és vàlida',
        errorMessageUserNotExist:'Aquest usuari no existeix',
        errorMessageToken:'El token no és vàlid',
        errorMessageAlreadyRegistered: 'Aquest usuari ja està registrat',
        errorMessageInvalidUser: 'No tens permisos per a realitzar aquesta acció',
        errorMessageDateExpires: 'La data ha expirat',
        errorMessageNameAndSurname: 'Introduïu un nom i un cognom',
        successMessageUserDeletedCode: 'Eliminat correctament',
        successMessageUserUpdateCode: 'Codi d\'accés actualitzat amb èxit',
        successMessageUserRegister: 'Creat amb èxit',
        successMessageVerifiedCode: 'Codi correcte',
        registerTitle: 'Registra\'t',
        registerLabelLogin: 'Ja tens compte, inicia sessió',
        errorMessageSomethingWrong: 'Error, alguna cosa que heu introduït està malament',
        errorMessageNoAcceptTerms: "Has d'acceptar les condicions ",
        labelNoTimeSelected: 'Sense temps seleccionat',
        secretaryOptionsChatModalTitle: 'Escull una de les opcions',
        secretaryBtnSendModerator: 'Enviar al Moderador',
        secretaryBtnSendResponseUser: 'Respondre  al Usuari',
        secretaryOptionsChatModalAlertTitle: 'Estas segur que vols enviar-ho',
        secretaryBtnSendOk: 'Enviar',
        secretaryBtnSendCancel: 'Cancel·lar',
        secretaryTabQuestions: 'Preguntes',
        eventInformationTitle: "Informació de l'Esdeveniment",
        eventInformationTitleEn: 'Títol en Anglès',
        eventInformationTitleEs: 'Títol en Espanyol',
        eventInformationTitleCat: 'Titol en Català',
        eventInformationSubTitleEn: 'Subtítol en Anglès',
        eventInformationSubTitleEs: 'Subtítol en Espanyol',
        eventInformationSubTitleCatalan: 'Subtítol en Catalan',
        eventInformationPlayerUrlEn: 'Url del Player en Anglès',
        eventInformationPlayerUrlEs: 'Url del Player en Espanyol',
        eventInformationPlayerUrlCat: 'Url del Player en Català',
        eventInformationQuestionsEn: 'Preguntes en Anglès',
        eventInformationQuestionsEs: 'Preguntes en Espanyol',
        eventInformationQuestionsCat: 'Preguntes en Català',
        eventInformationGoBackBtn: 'Enrrera',
        eventInformationActiveChat: 'Xat activat',
        eventInformationTotalUsers: 'Usuaris totals',
        eventSuccessModified: 'Canvis Guardats',
        userPlayerMessageArrived: 'Tens un nou missatge',
        secretaryShowGraphs: 'Mostrar Gràfics',
        secretaryQuestionSended: 'Pregunta  Enviada',
        secretarySendQuestion: 'Envia la Pregunta',
        secretaryShowAnswers: 'Mostra les Respostes',
        secretaryInputSeconds: 'Introdueixi el número de segons',
        secretaryTitleResponseTime: 'Temps de Resposta',
        dashboardTitleGraph: 'Pregunta',
        dashboardTitleCharts: 'Gràfics',
        adminModalWebinarStartImageCat: 'Afegeix una imatge de portada inicial en Català',
        adminModalWebinarEndImageCat: 'Afegeix una imatge de portada final en Català',
        adminModalWebinarStartImageEs: 'Afegeix una imatge de portada inicial en Espanyol',
        adminModalWebinarEndImageEs: 'Afegeix una imatge de portada final en Espanyol',
        adminModalWebinarStartImageEn: 'Afegeix una imatge de portada inicial en Anglès',
        adminModalWebinarEndImageEn: 'Afegeix una imatge de portada final en Anglès',
        adminModalWebinarBrowseBtnLabel: 'Buscar',
        adminModalWebinarPlaceholderUploadImage: 'Selecciona una imatge...',
        adminModalWebinarUploadBtnLabel: 'Carregar imatge',
        secretaryWebinarTabChatLabel: 'Xat amb el secretari',
        moderatorWebinarTabGeneralLabel: 'General',
        moderatorWebinarTabChatLabel: 'Xat amb el moderador',
        adminBtnManageEvent: 'Gestionar esdeveniment',
        eventInformationActiveQuestions: 'Preguntes activades',
        eventInformationActiveChroma: 'Chroma activat',
        adminPanicPosterLabel: 'Pòster del pànic',
        registerLegalText1: "La Barcelona Time Use Initiative for a Healthy Society utilitzarà les seves dades personals per gestionar el registre a la Setmana dels Horaris 2020; enviar informació rellevant respecte a l'esdeveniment; i, si així ho ha indicat, enviar comunicacions sobre l'activitat de l'associació. Per utilitzar el seu dret a accedir, rectificar, suprimir, limitar i oposar les seves dades personals, ens pot contactar a info@timeuse.barcelona.  This question is required.",
        acceptTerms: "He llegit, entenc i accepto el tractament de dades personals",
        reciveInfoYes: 'SÍ',
        reciveInfoNo: 'NO',
        reciveLabelInfo: 'Vol subscriure\'s a la newsletter de ”Barcelona Time Use”.'



    }
};

const i18n = new VueI18n({
    locale: 'es', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});

export default i18n;
